<template>
  <el-aside class="app-aside" style="width: 245px">
    <el-menu
      :default-active="$route.path"
      text-color="#ABBDDA"
      active-text-color="#fff"
      class="aside-vertical"
      :unique-opened="true"
      router
    >
      <div v-for="(item, i) in asideList" :key="i + 't'" v-if="isShow">
        <el-menu-item
          :index="item.url"
          :key="i"
          v-if="item.children.length == 0"
        >
          <i :class="item.icon"></i>
          <span :route="item.url" slot="title">{{ item.name }}</span>
        </el-menu-item>
        <el-submenu :index="i + 'b'" v-if="item.children.length > 0">
          <template slot="title">
            <i class="iconfont" :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(it, i) in item.children"
              :key="i"
              :index="it.url"
            >
              {{ it.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>

      <!-- <el-menu-item index="/device-access/fire-manage">
            <i class="icon-shipinjiankong"></i>
            <span  slot="title">消防设备组管理</span>
        </el-menu-item>       -->
      <!-- 设备 -->
      <el-submenu
        v-for="(item, index) in productList"
        :key="index"
        :index="'/aircon-device/' + index"
        v-show="actPath == '/device-manage'"
      >
        <template slot="title">
          <i class="iconfont icon-weibiaoti1"></i>
          <span slot="title">{{ item.productCategoryName }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item
            v-for="(it, index) in item.productForeignList"
            :key="index"
            :index="
              '/device-manage/aircon-device?id=' +
                it.productId +
                '&name=' +
                it.productName
            "
          >
            {{ it.productName }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>
<script>
export default {
  name: "app-aside",
  data() {
    return {
      showAside: true,
      productList: [],
      themeInfo: {},
      premissions: [],
      asideList: [],
      isShow: false,
      actPath: "",
      arr: [], //当前url切割组成的数组
      color: false
    };
  },
  watch: {
    $route(to, from) {
      this.arr = to.path.split("/");
      this.actPath = "/" + this.arr[1];
      if (this.actPath == "/device-manage") {
        if (this.appId) {
          this.getDeviceAside();
        }
      }
    }
  },
  created() {
    this.appId = sessionStorage.getItem("appId") || "";
    this.arr = this.$route.path.split("/");
    this.actPath = "/" + this.arr[1];
    if (this.appId && this.actPath == "/device-manage") {
      this.getDeviceAside();
    }
    this.themeInfo = JSON.parse(sessionStorage.getItem("themeInfo"));
    this.asideList = JSON.parse(sessionStorage.getItem("asideList"));

    window.addEventListener("setItem", () => {
      this.asideList = sessionStorage.getItem("asideList");
      if (this.asideList.length > 0) {
        if (this.asideList[0].url) {
          this.$router.push(this.asideList[0].url);
        } else if (this.asideList[0].children.length > 0) {
          this.$router.push(this.asideList[0].children[0].url);
        }
      }
      this.isShow = true;
    });

    // 不知道为什么 写在这里才生效
    this.$nextTick(() => {
      this.isShow = true;

      if (this.asideList.length > 0 && this.arr.length <= 2) {
        if (this.asideList[0].url) {
          this.$router.push(this.asideList[0].url);
        } else if (this.asideList[0].children.length > 0) {
          this.$router.push(this.asideList[0].children[0].url);
        }
      }
    });
  },
  mounted() {
    // 改变主题颜色
    // this.$bus.$off("changeTheme")
    // this.$bus.$on("changeTheme", (n) => {
    //     this.themeInfo = n;
    // });

    // 重新加载侧边栏
    this.$bus.$off("change_menuIndex1");
    this.$bus.$on("change_menuIndex1", () => {
      this.isShow = false;
      this.asideList = JSON.parse(sessionStorage.getItem("asideList"));
      this.$nextTick(() => {
        if (this.asideList && this.asideList.length > 0) {
          if (this.asideList[0].url) {
            this.$router.push(this.asideList[0].url);
          } else if (this.asideList[0].children.length > 0) {
            this.$router.push(this.asideList[0].children[0].url);
          }
        }

        this.isShow = true;
      });
    });
  },
  methods: {
    // 设备管理下的设备列表
    getDeviceAside() {
      let params = {
        appId: this.appId
      };
      this.$http
        .get(
          this.$api.getApiAddress(
            "/tenementplatformmgn/l/saas/device-category/select-productCategory-all",
            "API_ROOT"
          ),
          params
        )
        .then(res => {
          this.productList = res.data;
        });
    },
    defaultActive() {
      let arr = this.$route.path.split("/");
      let index = "";
      for (let i = 1; i < arr.length; i++) {
        index += "/" + arr[i];
      }
      return index;
    }
  }
};
</script>
<style>
.el-submenu__title {
  padding-left: 24px !important;
}
.app-aside .el-submenu__icon-arrow {
  font-size: 15px;
}
.el-menu {
  background-color: #1e3159;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #1e3159;
}
.app-aside .el-icon-s-operation {
  width: 18px;
  margin-right: 0;
}
</style>

<style lang="less" scoped>
.app-aside {
  width: 180px;
  .el-submenu__title i {
    color: #abbdda;
    font-size: 18px;
  }
  .el-menu-item span {
    margin-left: 5px;
  }
  .aside-vertical {
    height: 100%;
    padding-top: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/layout/app-aside1.vue